import { Fragment } from 'react';

import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG } from 'CorePackage/MainModule/constants/dateFormat';

import { KnmSubtitle } from './KnmSubtitle';
import styles from './styles.module.scss';
import { parseErknmValue } from '../common/parseErknmValue';

interface IErknmResultProps {
  passportData: IKnmPreview;
}

export const ErknmResult = ({ passportData }: IErknmResultProps) => {
  return (
    <div className={styles.ColumnContent}>
      {passportData?.inspectionErknm?.organizations?.length && (
        <KnmSubtitle title="Сведения о решениях, принятых по результатам КНМ">
          {passportData?.inspectionErknm?.organizations.map(
            (item, index) =>
              item?.resultDecisions &&
              item?.resultDecisions.length && (
                <Fragment key={index}>
                  <span className={styles.SectionTitle}>Проверяемое лицо #{index + 1}</span>
                  {item.resultDecisions?.map((resultItem, resultIndex) => (
                    <Fragment key={resultIndex}>
                      {resultItem?.kindDecision?.name && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>Вид решения</div>
                          <div className={styles.ColValue}>{resultItem.kindDecision.name}</div>
                        </div>
                      )}
                      {resultItem.noteLawsuits && resultItem.noteLawsuits.length && (
                        <KnmSubtitle title="Описание решения">
                          {resultItem.noteLawsuits.map((note, noteIndex) => (
                            <div className={styles.Row} key={noteIndex}>
                              <div className={styles.ColText}>Описание #{noteIndex + 1}</div>
                              <div className={styles.ColValue}>{note.value}</div>
                            </div>
                          ))}
                        </KnmSubtitle>
                      )}
                      {resultItem.numberDecision && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>Номер решения</div>
                          <div className={styles.ColValue}>{resultItem.numberDecision}</div>
                        </div>
                      )}
                      {resultItem.dateDecision && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>Дата решения</div>
                          <div className={styles.ColValue}>
                            {formatDate({ date: resultItem.dateDecision, dateFormat: DATE_FORMAT_LONG })}
                          </div>
                        </div>
                      )}
                      {resultItem.fioSigner && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>ФИО подписавшего решение</div>
                          <div className={styles.ColValue}>{resultItem.fioSigner}</div>
                        </div>
                      )}
                      {resultItem.titleSigner && resultItem.titleSigner.value && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>Должность лица, подписавшего решение</div>
                          <div className={styles.ColValue}>
                            {parseErknmValue<{ title?: string }>(resultItem.titleSigner.value)?.title}
                          </div>
                        </div>
                      )}
                      {resultItem.inspectors && resultItem.inspectors.length && (
                        <KnmSubtitle
                          title="Должностные лица контрольного (надзорного) органа,
                          участвовавшие в контрольных (надзорных) мероприятиях"
                        >
                          {resultItem.inspectors.map((inspector, inspectorIndex) => (
                            <Fragment key={inspectorIndex}>
                              <span className={styles.SectionTitle}>Сведение #{inspectorIndex + 1}</span>
                              <div className={styles.Row}>
                                <div className={styles.ColText}>ФИО</div>
                                <div className={styles.ColValue}>{inspector.fullName}</div>
                              </div>
                              {inspector.position && inspector.position.value && (
                                <div className={styles.Row}>
                                  <div className={styles.ColText}>Должность</div>
                                  <div className={styles.ColValue}>
                                    {parseErknmValue<{ title?: string }>(inspector.position.value)?.title}
                                  </div>
                                </div>
                              )}
                            </Fragment>
                          ))}
                        </KnmSubtitle>
                      )}
                      {typeof resultItem.isProsecution === 'boolean' && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>
                            Сведения о привлечении к ответственности по результатам контрольных (надзорных) мероприятий
                          </div>
                          <div className={styles.ColValue}>{resultItem.isProsecution ? 'Да' : 'Нет'}</div>
                        </div>
                      )}
                      {resultItem.responsibleEntities && resultItem.responsibleEntities.length && (
                        <KnmSubtitle
                          title="Сведения о привлеченных к ответственности лицах
                          (включая индивидуальных предпринимателей, юридических лиц, должностных лиц)"
                        >
                          {resultItem.responsibleEntities.map((responsibleEntitie, responsibleEntitieIndex) => (
                            <Fragment key={responsibleEntitieIndex}>
                              <span className={styles.SectionTitle}>Лицо #{responsibleEntitieIndex + 1}</span>
                              {responsibleEntitie.type && responsibleEntitie.type.name && (
                                <div className={styles.Row}>
                                  <div className={styles.ColText}>Тип</div>
                                  <div className={styles.ColValue}>{responsibleEntitie.type.name}</div>
                                </div>
                              )}
                              {responsibleEntitie.inn && (
                                <div className={styles.Row}>
                                  <div className={styles.ColText}>ИНН</div>
                                  <div className={styles.ColValue}>{responsibleEntitie.inn}</div>
                                </div>
                              )}
                              {responsibleEntitie.ogrn && (
                                <div className={styles.Row}>
                                  <div className={styles.ColText}>ОГРН</div>
                                  <div className={styles.ColValue}>{responsibleEntitie.ogrn}</div>
                                </div>
                              )}
                              {responsibleEntitie.organizationName && (
                                <div className={styles.Row}>
                                  <div className={styles.ColText}>Наименование</div>
                                  <div className={styles.ColValue}>{responsibleEntitie.organizationName}</div>
                                </div>
                              )}
                              {responsibleEntitie.responsibilityType && responsibleEntitie.responsibilityType.name && (
                                <div className={styles.Row}>
                                  <div className={styles.ColText}>Сведения о виде назначенного наказания</div>
                                  <div className={styles.ColValue}>{responsibleEntitie.responsibilityType.name}</div>
                                </div>
                              )}
                              {responsibleEntitie.punishmentAmount && (
                                <div className={styles.Row}>
                                  <div className={styles.ColText}>Размер наказания</div>
                                  <div className={styles.ColValue}>{responsibleEntitie.punishmentAmount}</div>
                                </div>
                              )}
                              {responsibleEntitie.punishmentAmountMeasure && (
                                <div className={styles.Row}>
                                  <div className={styles.ColText}>Единица измерения наказания</div>
                                  <div className={styles.ColValue}>{responsibleEntitie.punishmentAmountMeasure}</div>
                                </div>
                              )}
                              {responsibleEntitie.structuresNPA && (
                                <KnmSubtitle
                                  title="Структурные единицы нормативных правовых актов, содержащих информацию
                                      о мерах ответственности контролируемых лиц"
                                >
                                  {responsibleEntitie.structuresNPA.map((structureNPA, structureIndex) => (
                                    <Fragment key={structureIndex}>
                                      <span className={styles.SectionTitle}>
                                        Структурная единица #{responsibleEntitieIndex + 1}
                                      </span>
                                      <div className={styles.Row}>
                                        <div className={styles.ColText}>Значение</div>
                                        <div className={styles.ColValue}>{structureNPA.value}</div>
                                      </div>
                                    </Fragment>
                                  ))}
                                </KnmSubtitle>
                              )}
                            </Fragment>
                          ))}
                        </KnmSubtitle>
                      )}
                    </Fragment>
                  ))}
                </Fragment>
              ),
          )}
        </KnmSubtitle>
      )}
    </div>
  );
};
